import {Chips, IChipsProps} from '@vidazoo/ui-kit';
import {useInjex} from '@injex/react-plugin';
import {observer} from 'mobx-react';
import {useState} from 'react';
import LocalStorageManager from '../../managers/LocalStorageManager.mdl';
import {ReportingChipKind} from '../../utils/ReportingChipUsage';
import {rankBySearch} from '../../utils/searchRank';

interface Props extends IChipsProps {
    usageKind: ReportingChipKind;
    vertical: string;
}

export default observer(function ReportingChips({usageKind, vertical, dataSource, onSelect, onInputChange, onFocus, ...props}: Props) {
    const [inject] = useInjex();
    const [query, setQuery] = useState('');
    const usage = inject<LocalStorageManager>('localStorageManager').reportingChipUsage;
    const onSelectItem: IChipsProps['onSelect'] = (value, label, ...args) => {
        setQuery('');
        onSelect?.(value, label, ...args);
        usage.record(vertical, usageKind, [value]);
    };
    // Search relevance first; usage order breaks ties between equally relevant matches.
    const ranked = rankBySearch(usage.rank(vertical, usageKind, dataSource), query,
        props.itemLabelKey || 'label', props.itemValueKey || 'value');

    return <Chips {...props} dataSource={ranked} onSelect={onSelectItem}
        onInputChange={event => {
            setQuery(event.target.value);
            onInputChange?.(event);
        }}
        onFocus={event => {
            setQuery(event.target.value);
            onFocus?.(event);
        }}/>;
});
